<template>
  <div class="row">
    <div class="col-md-6">
      <Panel>
        <div slot="header">
          <h2>Allies</h2>
        </div>

        <div slot="body">
          <PeerTable
            slot="result"
            :peers="profile.allies"
          ></PeerTable>
        </div>
      </Panel>
    </div>

    <div class="col-md-6">
      <Panel>
        <div slot="header">
          <h2>Rivals</h2>
        </div>

        <div slot="body">
          <PeerTable
            slot="result"
            :peers="profile.rivals"
          ></PeerTable>
        </div>
      </Panel>
    </div>
  </div>
</template>

<script>
  import Panel from '@/legacy/components/widgets/Panel';
  import PeerTable from '@/legacy/components/PeerTable';
  import Profile from '@/legacy/lib//model/Profile';
  import { metaFactory } from '@/legacy/lib//template';

  export default {
    metaInfo () {
      return metaFactory ({
        title: `${this.profile.name} Peers`,
        description: `Discover ${this.profile.name}'s greatest allies and most feared foes.`
      });
    },

    props: {
      profile: {
        type: Profile
      }
    },

    components: {
      Panel,
      PeerTable
    }
  };
</script>

<style lang="scss">

</style>